module.exports = __webpack_public_path__ + "img/s-Imoo-p-1.776c7a27.png";